import { render } from "./ListaPreguntas.vue?vue&type=template&id=c7f60e0e&scoped=true"
import script from "./ListaPreguntas.vue?vue&type=script&lang=js"
export * from "./ListaPreguntas.vue?vue&type=script&lang=js"

import "./ListaPreguntas.vue?vue&type=style&index=0&id=c7f60e0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7f60e0e"]])

export default __exports__